import React from "react";
import { Table, Select, Button, Label } from "semantic-ui-react";
import "./Paso3Ruta.scss";

const fmt = (v, d = 1) => (isFinite(v) ? Number(v).toLocaleString("es-AR", { minimumFractionDigits: d, maximumFractionDigits: d }) : "—");
const fmt0 = (v) => fmt(v, 0);

const SI_NO_VACIO = [
  { key: "", value: "", text: "—" },
  { key: "si", value: "si", text: "Sí" },
  { key: "no", value: "no", text: "No" },
];
const SI_NO = [
  { key: "no", value: "no", text: "No" },
  { key: "si", value: "si", text: "Sí" },
];

// Portado de vP3() del prototipo (línea 633).
export function Paso3Ruta({ record, computed, patchSection }) {
  const route = record.route || {};
  const params = computed?.params || {};
  const calc = computed?.calc || {};

  const setRoute = (patch) => patchSection("route", { ...route, ...patch }, { immediate: true });

  const smeThreshold = params.sme_tco2e ?? 10000;
  const s1s2loc = (calc.scope1 || 0) + (calc.scope2Location || 0);

  return (
    <div className="sbti-paso3">
      <div className="sbti-pagehead">
        <div className="sbti-crumb">Paso 3 · Ruta de validación</div>
        <h2>¿Ruta corporativa o ruta <span className="sbti-pgram"><span>PYME</span></span> simplificada?</h2>
        <p className="sbti-sub">
          La ruta PYME (definición vigente desde 01-ene-2024) simplifica la validación: solo objetivos near-term
          A1+A2 predefinidos, sin objetivo A3 obligatorio, sin etapa de compromiso, tarifa reducida.
        </p>
      </div>

      <div className="sbti-card">
        <h3>Chequeo de elegibilidad PYME</h3>
        <Table celled compact>
          <Table.Header>
            <Table.Row><Table.HeaderCell>Condición</Table.HeaderCell><Table.HeaderCell>Estado / respuesta</Table.HeaderCell></Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell><b>Condición excluyente:</b> A1 + A2 (location-based) &lt; {fmt0(smeThreshold)} tCO₂e</Table.Cell>
              <Table.Cell>
                {s1s2loc > 0 ? (
                  <Label color={calc.smeEligibleByEmissions ? "green" : "red"}>
                    {fmt(s1s2loc)} tCO₂e — {calc.smeEligibleByEmissions ? "cumple" : "no cumple"}
                  </Label>
                ) : (
                  <Label>cargar Paso 1</Label>
                )}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Menos de 250 empleados (FTE)</Table.Cell>
              <Table.Cell><Select options={SI_NO_VACIO} value={route.employees250 || ""} onChange={(_, d) => setRoute({ employees250: d.value })} /></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Facturación anual &lt; €50 M</Table.Cell>
              <Table.Cell><Select options={SI_NO_VACIO} value={route.revenue50 || ""} onChange={(_, d) => setRoute({ revenue50: d.value })} /></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Activos totales &lt; €25 M</Table.Cell>
              <Table.Cell><Select options={SI_NO_VACIO} value={route.assets25 || ""} onChange={(_, d) => setRoute({ assets25: d.value })} /></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>¿Opera en sector FLAG obligatorio?</Table.Cell>
              <Table.Cell><Select options={SI_NO} value={route.flagSector || "no"} onChange={(_, d) => setRoute({ flagSector: d.value })} /></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>¿Es subsidiaria de una empresa que presenta por ruta corporativa?</Table.Cell>
              <Table.Cell><Select options={SI_NO} value={route.subsidiary || "no"} onChange={(_, d) => setRoute({ subsidiary: d.value })} /></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>¿Está obligada a usar criterios sectoriales SDA?</Table.Cell>
              <Table.Cell><Select options={SI_NO} value={route.sectorSda || "no"} onChange={(_, d) => setRoute({ sectorSda: d.value })} /></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <p className="sbti-hint">
          Regla: emisiones &lt; {fmt0(smeThreshold)} tCO₂e <b>y al menos 3</b> de las 4 condiciones (empleados,
          facturación, activos, no-FLAG); además no ser institución financiera ni de oil &amp; gas, ni subsidiaria
          de un presentante corporativo.
        </p>

        {s1s2loc > 0 && (
          calc.smeOK ? (
            <div className="sbti-note sbti-note--ok">
              <b>Elegible para la ruta PYME</b> ({calc.smeCriteriaMet} de 4 condiciones + emisiones bajo el umbral).
              Presentación directa, objetivos near-term predefinidos A1+A2, compromiso de medir y reducir A3.
              {params.sme_fee ? ` Tarifa: ${params.sme_fee}.` : ""}
            </div>
          ) : (
            <div className="sbti-note">
              <b>Ruta corporativa.</b> Aplica el proceso completo: near-term A1+2 (mín. 1.5 °C) + objetivo A3 si
              supera el {params.umbral_a3 ?? 40}%, opción de compromiso (24 meses).
              {params.corp_fee ? ` ${params.corp_fee}.` : ""}
            </div>
          )
        )}

        <div className="sbti-paso3__choice">
          <Button primary={route.type === "sme"} basic={route.type !== "sme"} onClick={() => setRoute({ type: "sme" })}>
            Elegir ruta PYME
          </Button>
          <Button primary={route.type === "corp"} basic={route.type !== "corp"} onClick={() => setRoute({ type: "corp" })}>
            Elegir ruta corporativa
          </Button>
        </div>

        <div className="sbti-src">
          <b>Fuentes:</b> «SBTi Announces Updated SME Definition and Fees» (definición vigente 01-01-2024); FAQs for
          SMEs v6.2: FTE, exclusión FI/O&amp;G, sin etapa de compromiso.
        </div>
      </div>
    </div>
  );
}
